import { createUrl } from '@/utils';

const client = createUrl('service-api');

const preregister = (tin: string) => client(`preregister/${tin}`);

export const companyEndpoints = {
  preregister,
};
